module.exports = __webpack_public_path__ + "img/checked_dmktz.2ef2db85.svg";